<template>
  <div class="card">
    <div class="card-body">
      <div v-if="loginError" class="alert alert-danger">Contraseña incorrecta</div>
      <div v-if="errorNews" class="alert alert-danger">Las contraseñas no coinciden</div>
      <div class="text-center mb-4 mt-1">
        <h3 class="generalTitle">Cambiar contraseña</h3>
      </div>
      <form @submit.prevent="submit()">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="oldPassword">Contraseña antigua</label>
              <input type="password" class="form-control generalInput" id="oldPassword"
                v-model.trim="v$.oldPassword.$model">
              <div v-if="v$.oldPassword.$dirty">
                <small class="form-text text-danger" v-if="!v$.oldPassword.required">Campo requerido</small>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="newPassword">Contraseña nueva</label>
              <input type="password" class="form-control generalInput" id="newPassword"
                v-model.trim="v$.newPassword.$model">
              <div v-if="v$.newPassword.$dirty">
                <small class="form-text text-danger" v-if="!v$.newPassword.required">Campo requerido</small>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="confirmPassword">Confirmar contraseña nueva</label>
              <input type="password" class="form-control generalInput" id="confirmPassword"
                v-model.trim="v$.confirmPassword.$model">
              <div v-if="v$.confirmPassword.$dirty">
                <small class="form-text text-danger" v-if="!v$.confirmPassword.required">Campo requerido</small>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12 text-center">
            <button class="btn btn-primary generalPrimaryButton" v-bind:class="{ disabled: v$.$invalid }"
              :disabled="v$.$invalid" @click="submit()">
              <span v-if="!loading">Cambiar</span>
              <img v-if="loading" src="../../../assets/loader.svg" height="20" alt="">
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <ConfirmChange :id="'confirmChange'" :modalTitle="'CAMBIO REALIZADO'" :class="'modal-md'" @closeModal="closeModal()">
  </ConfirmChange>
  <ModalError :id="'modalError'" :modalTitle="'SE HA PRODUCIDO UN ERROR'" :class="'modal'" :showFooter="false"
    :message="errorMessage" :code="errorCode" />
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import axios from 'axios';
import ConfirmChange from './templates/ConfirmChange.vue';
import { Modal } from "bootstrap";
import ModalError from '../Shared/ModalError.vue'
import { Modal as ModalBootstrap } from "bootstrap";

export default {
  name: 'ChangePassword',
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      user: '',
      confirmPassword: '',
      oldPassword: '',
      newPassword: '',
      loginError: false,
      loading: false,
      errorNews: false,
      errorMessage: '',
      errorCode: '',
    };
  },
  components: {
    ConfirmChange,
    ModalError
  },
  validations() {
    return {
      confirmPassword: {
        required
      },
      oldPassword: {
        required
      },
      newPassword: {
        required
      },
    }
  },
  methods: {
    submit() {
      this.loading = true;
      if (this.confirmPassword == this.newPassword) {
        let bodyToSend = {
          username: this.$cookies.get('username'),
          password: this.oldPassword,
          userType: "BACKOFFICE"
        }
        axios.post('/user/login', bodyToSend)
          .then((response) => {
            console.log(response)
            let bodyToSend = {
              username: this.$cookies.get('username'),
              oldPassword: this.oldPassword,
              newPassword: this.newPassword,
              userType: "BACKOFFICE"
            }
            axios.post('/user/updatePassword', bodyToSend)
              .then((res) => {
                console.log(res)
                this.loginError = false;
                this.loading = false;
                this.errorNews = false;
                var myModal = new Modal(document.getElementById('confirmChange'))
                myModal.show()
                this.oldPassword = '';
                this.newPassword = '';
                this.confirmPassword = '';
              })
          }).catch((error) => {
            this.errorCode = error.response.data.code
            this.errorMessage = error.response.data.message
            var myModal = new ModalBootstrap(document.getElementById('modalError'))
            myModal.show()
            this.loginError = true;
            this.loading = false;
            this.errorNews = false;
          })
      } else {
        this.loading = false;
        this.errorNews = true;
        this.loginError = false;
      }
    },
  },
}
</script>

<style lang="scss"></style>
